// extracted by mini-css-extract-plugin
export var carrierNotice = "_la-5";
export var carrierNoticePlaceholder = "_la-6";
export var deliveryRow = "_la-c";
export var fixedHeight = "_la-4";
export var freightLogo = "_la-b";
export var fullWidth = "_la-3";
export var priceColumn = "_la-7";
export var radioSelected = "_la-9";
export var radioUnselected = "_la-8";
export var selectedOption = "_la-2";
export var selectedOptionContainer = "_la-1";
export var selection = "_la-0";
export var tallSkeletonText = "_la-a";